import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Alert, Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap'
import Controller from './controller'
import * as actionAuth from './../../store/auth/actions'
import logo from './../../assets/logo.png'
import './styles.css'


class Login extends Controller {
  render() {
    return (
      <div className="auth-login-page">
        <div className="auth-wrapper">
          <Row>
            <Col xs={12} md={{ span: 4, offset: 4 }}>
              <Card className="mb-0 d-flex justify-content-center p-1">
                <Card.Img variant="top" src={logo} />
                <Card.Header className="p-0">
                  <div className="card-title mb-0">
                    <h4 className="text-center">Welcome Back</h4>
                  </div>
                </Card.Header>
                <Card.Body>
                  <div className="divider mb-2">
                    <div className="divider-text text-uppercase text-muted">
                      <small>login with registered email</small>
                    </div>
                  </div>
                  {this.state.alertShow && (
                    <Alert variant={this.state.alertVariant} onClose={value => this.handleAlertClose(value)} dismissible>
                      {this.state.alertMessage}
                    </Alert>
                  )}
                  <Form onSubmit={evt => this.state.passSuccess ? this.loginOtp(evt) : this.loginPassword(evt)}>
                    <Form.Group className="form-group">
                      <Form.Control
                        autoComplete="off"
                        name="email"
                        placeholder="E-mail"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        readOnly={this.state.passSuccess}
                      />
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Control
                        autoComplete="off"
                        name="password"
                        type="password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        readOnly={this.state.passSuccess}
                      />
                    </Form.Group>
                    {this.state.passSuccess && (
                      <>
                        <Form.Group className="form-group">
                          <Form.Control
                            type="password"
                            name="otp"
                            placeholder="OTP"
                            autoComplete="off"
                            value={this.state.otp}
                            onChange={this.handleInputChange}
                          />
                        </Form.Group>
                        <p>
                          We have sent it to your email,<br />
                          OTP only valid for 3 minutes and for 1 attempt
                        </p>
                      </>
                    )}
                    <Form.Group className="form-group d-flex justify-content-end">
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </Form.Group>
                    <Form.Group>
                      {this.state.passSuccess ? (
                        <Button type="submit" variant="primary" className="btn-block" disabled={this.props.loading}>
                          Login
                          {this.props.loading && (
                            <Spinner animation="border" variant="light" size="sm" className="ml-1" />
                          )}
                        </Button>
                      ) : (
                        <Button type="submit" variant="primary" className="btn-block" disabled={this.props.loading}>
                          Next
                          {this.props.loading ? (
                            <Spinner animation="border" variant="light" size="sm" style={{ marginLeft: '5px' }} />
                          ) : (
                            <i className="bx bx-right-arrow-alt" style={{ marginLeft: '5px' }} />
                          )}
                        </Button>
                      )}
                    </Form.Group>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

const mapState = state => {
  const { authReducers } = state
  return {
    loading: authReducers.loading,
    otpResponse: authReducers.loginOtpResponse,
    passResponse: authReducers.loginPassResponse,
  }
}

const mapDispatch = dispatch => ({
  loginOtp: payload => dispatch(actionAuth.loginOtp(payload)),
  loginPassword: payload => dispatch(actionAuth.loginPassword(payload)),
})

export default connect(mapState, mapDispatch)(Login)
